// TokenDetail.js
import React from "react";
import TokenDetailHeader from "../components/main/detail/TokenDetailHeader";
import DetailTokenCard from "../components/main/detail/DetailTokenCard";
import TokenExchange from "../components/main/detail/TokenExchange";

import ProgressBar from "@ramonak/react-progress-bar";

const TokenDetail = ({ token }) => {
  // Receive token and onPageChange props
  // Render token detail information
  return (
    <div>
      <TokenDetailHeader
        tokenImg={token.tokenImg}
        tokenName={token.tokenName}
      />
      <div>
        <div>
          <p></p>
          <div className="text-white text-[10px] xs:text-[12px] md:text-[16px]">
            {/* <div>
              <div className="border border-b-[#333333] border-transparent flex text-[#8D93B7] pb-[11px]">
                <p className="flex justify-center items-center w-[19%]">
                  Ranking
                </p>
                <p className="flex justify-center items-center w-[33%]">USER</p>
                <p className="flex justify-center items-center w-[19%]">
                </p>
                <p className="flex justify-center items-center w-[29%] md:w-[19%]">
                </p>
                <p className="flex justify-center items-center md:w-[10%]"></p>
              </div>
            </div> */}
            {/* {currentTraderData.map((item, index) => (
              <div key={startIndex + index}>
                <Value
                  traderdata={item}
                  number={startIndex + index + 1}
                  displayValue={item[displayValue]}
                  displayTotalPoint={item[displayTotalPoint]}
                />
              </div>
            ))} */}
          </div>
        </div>
        <div>
          <DetailTokenCard
            tokenImg={token.tokenImg}
            tokenName={token.tokenName}
            tokenDescription={token.tokenDescription}
          />
          <TokenExchange token={token} />
          <div className="text-white w-[316px] rounded-[8px] py-[20px] px-[25px] bg-[#0A0A0A] mt-[20px] border border-transparent hover:border-[#9945FF]">
            <p className="pb-1 text-[12px] text-white">
              Market cap: {((token.progress / 100) * 59).toFixed(2)} K
            </p>
            <ProgressBar
              completed={token.progress}
              height="8px"
              bgColor="#19FB9B"
              className="rounded-[50px] py-[17px]"
              baseBgColor="#333333"
              labelSize="0px"
            />
            <p className="text-[11px] text-[#9CA3AF]">
              There are still 29,099,999 tokens available for sale in the pool,
              and X SOL is lacking for listing on DEX
            </p>
          </div>
          <div className="text-white w-[316px] rounded-[8px] py-[20px] px-[25px] bg-[#0A0A0A] mt-[20px] border border-transparent hover:border-[#9945FF]">
            <p className="pb-1 text-[12px] text-white">
              BOOST KING PROGRESS: {((token.progress / 100) * 59).toFixed(2)} K
            </p>
            <ProgressBar
              completed={token.progress}
              height="8px"
              bgColor="#9945FF"
              className="rounded-[50px] py-[17px]"
              baseBgColor="#333333"
              labelSize="0px"
            />
            <p className="text-[11px] text-[#9CA3AF]">
              dethrone the current king at a $35 068 mcap
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TokenDetail;
